import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { useDeveloperPortalSupportAgentPermissions } from '../../hooks/useDeveloperPortalSupportAgentPermissions';

export const AlternativeStartPageSidebarItem = () => {
  const { canRead, loading, error } =
    useDeveloperPortalSupportAgentPermissions();

  if (loading || error || canRead) return null;

  return <SidebarItem icon={HomeOutlinedIcon} to="/" text="Home" />;
};
